import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMerge = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.829 5.254 6.5 2.925 4.171 5.254l-.758-.758L6.5 1.41l3.088 3.087-.76.758Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.25 11.375H1.084V10.29H3.25a2.682 2.682 0 0 0 2.71-2.706V2.166h1.08v5.418a3.768 3.768 0 0 1-3.79 3.79Z",
			fill: "var(--main-color)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.916 11.375H9.75a3.768 3.768 0 0 1-3.79-3.791h1.08a2.682 2.682 0 0 0 2.71 2.707h2.165v1.084Z",
			fill: "var(--main-color)"
		})
	]
});
export { SvgMerge as ReactComponent };
